import { FormTemplate, TextInput } from 'ui-builder';
import { CopyPlanAsGlobalRequest, Plan, usePlansAdminService } from 'nekst-api';
import { FormText, Separator } from 'features/nekst-widgets';
import React from 'react';
import { SetupAreaAndVersionDropdown } from '../../Admin';

export interface CopyToGlobalPlanForm {
  id: number;
  afterSubmitFunc?: (_data: Plan) => Promise<void>,
}

export function CopyToGlobalPlanForm(props: CopyToGlobalPlanForm) {
  const planService = usePlansAdminService();

  const afterSubmitFunc = async (data: Plan) => {
    props.afterSubmitFunc?.(data);
  };

  return (
    <FormTemplate<CopyPlanAsGlobalRequest, Plan>
      title="Copy"
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
      submitFormFunc={async (data) => {
        return planService.copyPlanAsGlobal(props.id, data);
      }}
      afterSubmitFunc={afterSubmitFunc}
    >
      <FormText>
        Enter a new workflow name.
      </FormText>
      <Separator />
      <TextInput source="name" label="Workflow name" />
      <SetupAreaAndVersionDropdown source="setupAreaId" label="Market"  />
    </FormTemplate>
  );
}
